import { TableFiltersBar } from '../TableFiltersBar';
import { accessGroupsFiltersConfig } from '../../utils/tableFilters';
import { formatResourceSets, getAccessGroupPath, getGroupRoleLabel } from '../../store';
import { COLORS, DATE_FORMAT_DEFAULT_DOT, OrderTypes } from '@/constants';
import { getFullDateFromISO } from '@/utils';
import { Box, ButtonIcon, Dropdown, ICONS_NAME, Table } from '@servicepipe/ui-components';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const AccessGroupsTable = ({
  data,
  loading,
  onPageChange,
  queryParams,
  totalPages,
  totalCount,
  onSortingChange,
  onFiltersChange,
  onDeleteGroup,
}) => {
  const { id: accountId } = useParams();
  const navigate = useNavigate();

  const sortingInitial = {
    id: queryParams.sortKey || '',
    desc: queryParams.sortDirection === OrderTypes.Desc,
  };

  const columns = [
    {
      minWidth: 100,
      width: 100,
      enableSorting: true,
      header: 'ID',
      id: 'id',
      body: 'id',
    },
    {
      minWidth: 200,
      enableSorting: true,
      header: 'Group name',
      id: 'name',
      body: 'name',
    },
    {
      minWidth: 200,
      header: 'Group description',
      id: 'description',
      body: ({ row }) => row?.original?.description ?? '-',
    },
    {
      minWidth: 140,
      header: 'Role',
      id: 'role',
      body: ({ row }) => getGroupRoleLabel(row?.original?.role),
    },
    {
      minWidth: 80,
      header: 'Users',
      id: 'usersCount',
      body: 'usersCount',
    },
    {
      minWidth: 220,
      header: 'Resources',
      id: 'resources',
      body: ({ row }) => formatResourceSets(row?.original?.resourceSets),
    },
    {
      minWidth: 160,
      header: 'Updated at',
      id: 'updatedAt',
      enableSorting: true,
      body: ({ getValue }) => getFullDateFromISO(getValue(), DATE_FORMAT_DEFAULT_DOT),
    },
    {
      id: 'actions',
      meta: { justify: 'center', variant: 'action' },
      width: 50,
      minWidth: 50,
      header: '',
      body: ({ row }) => {
        const { id, name } = row?.original ?? {};

        return (
          <Dropdown
            onClick={({ value }) => {
              if (value === 'edit' && id && accountId) {
                navigate(getAccessGroupPath(accountId, id));
              }

              if (value === 'delete' && id) {
                onDeleteGroup({ id: Number(id), name: name ?? '' });
              }
            }}
            options={[
              { value: 'edit', label: 'Edit group' },
              {
                value: 'delete',
                color: COLORS.errorLight,
                label: 'Delete group',
              },
            ]}
          >
            <ButtonIcon size="small" variant="ghost" icon={ICONS_NAME.moreHoriz} />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <Box direction="column" width="100%" minWidth="0">
      <TableFiltersBar
        filtersConfig={accessGroupsFiltersConfig}
        queryFilters={queryParams.filters ?? []}
        onFiltersChange={onFiltersChange}
      />

      <Table
        loading={loading}
        data={data}
        columns={columns}
        page={queryParams.page}
        size={queryParams.pageSize}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onSortingChange={onSortingChange}
        initialStateSort={sortingInitial}
        isFixedLayout
        noDataText="No access groups found. Try different filter values."
      />
    </Box>
  );
};
